import React from 'react';
import { Search, Server, Send, TrendingUp } from 'lucide-react';
import { sequence } from '../data/mock';

const icons = { Search, Server, Send, TrendingUp };

const ProcessSection = () => (
  <section id="process" className="py-24 lg:py-32 bg-paper-2 border-y border-[#E2E8F0] relative overflow-hidden" data-testid="process-section">
    <div className="absolute inset-0 grid-paper opacity-60 [mask-image:linear-gradient(to_bottom,transparent,black_30%,black_70%,transparent)]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16" data-reveal>
        <div className="lg:col-span-7">
          <p className="eyebrow mb-4">Process · Sequence view</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-[1.05]">
            Your project runs like a <span className="mark">well-built sequence.</span>
          </h2>
        </div>
        <p className="lg:col-span-5 text-slate text-base md:text-lg leading-relaxed">
          Clear steps, clear timing, no black boxes. You always know what's live, what's working and what's next.
        </p>
      </div>

      <ol className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        <svg className="hidden lg:block absolute top-[46px] left-[12.5%] right-[12.5%] w-[75%] h-2 overflow-visible" aria-hidden="true">
          <line x1="0" y1="4" x2="100%" y2="4" stroke="#10B981" strokeWidth="2" className="dash-flow" />
        </svg>
        {sequence.map((p, i) => {
          const Icon = icons[p.icon];
          return (
            <li
              key={p.day}
              data-reveal
              style={{ transitionDelay: `${i * 100}ms` }}
              data-testid={`process-step-${i + 1}`}
              className="panel panel-hover relative p-6 sm:p-7 bg-white"
            >
              <div className="flex items-center justify-between mb-7">
                <span className="relative w-[60px] h-[60px] rounded-2xl bg-ink text-white flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#10B981]" />
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border border-[#E2E8F0] text-[11px] font-mono font-semibold text-ink flex items-center justify-center">{i + 1}</span>
                </span>
                <span className="pill pill-ink">{p.day}</span>
              </div>
              <h3 className="font-display text-lg sm:text-xl font-bold text-ink mb-2">{p.title}</h3>
              <p className="text-slate text-sm leading-relaxed mb-5">{p.description}</p>
              <span className="pill pill-green">{p.tag}</span>
            </li>
          );
        })}
      </ol>
    </div>
  </section>
);

export default ProcessSection;
